export default __webpack_public_path__ + "static/media/hht2_sitcom_08.89a8f74d.png";